import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

const config = {
  apiKey: 'AIzaSyAOYyKN0x9Q4pZ2L1pJFJRj9lath8DMyj0',
  authDomain: 'swroller-1928d.firebaseapp.com',
  databaseURL: 'https://swroller-1928d.firebaseio.com',
  projectId: 'swroller-1928d',
  storageBucket: 'swroller-1928d.appspot.com',
  messagingSenderId: '244533957450',
  appId: '1:244533957450:web:31702c919e44805b86a7b3',
  measurementId: 'G-81VVY9TNCS'
}

firebase.initializeApp(config)

export const db = firebase.firestore()
export const auth = firebase.auth()
